import { createContext } from 'react';
export var AnalyticsContext = /*#__PURE__*/createContext({
  sendEvent: (name, data) => {
    console.warn("No event provider for ".concat(name).concat(data ? ', data: ' : ''), data);
  },
  debug: false,
  logger: undefined
});